import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Error from "../components/ui/loaders/Error";
import GlobalLoader from "../components/ui/loaders/GlobalLoader";
import { useGetProjectsQuery } from "../features/projects/projectApi";
import {
  useGetTaskQuery,
  useUpdateTaskMutation,
} from "../features/tasks/taskApi";
import { useGetTeamsQuery } from "../features/teams/teamApi";

const EditTask = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: teams } = useGetTeamsQuery();
  const { data: projects } = useGetProjectsQuery();
  const [updateTask, { isSuccess }] = useUpdateTaskMutation();

  const [state, setState] = React.useState({
    taskName: "",
    teamMember: "",
    projectName: "",
    deadline: "",
  });

  const { data: task, isLoading, isError } = useGetTaskQuery(id);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      id,
      data: {
        teamMember: teams.find((team) => team.name == state.teamMember),
        project: projects.find(
          (project) => project.projectName == state.projectName
        ),
        deadline: state.deadline,
        status: task.status,
        taskName: state.taskName,
      },
    };

    updateTask(data);
  };

  useEffect(() => {
    if (task) {
      setState({
        taskName: task.taskName,
        teamMember: task.teamMember.name,
        projectName: task.project.projectName,
        deadline: task.deadline,
      });
    }
  }, [task]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/");
    }
  }, [isSuccess, navigate]);

  if (isLoading) {
    return <GlobalLoader />;
  }

  if (isError) {
    return <Error />;
  }

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Create Task for Your Team
        </h1>
        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
                value={state.taskName}
                onChange={(e) =>
                  setState({ ...state, taskName: e.target.value })
                }
              />
            </div>
            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                name="teamMember"
                id="lws-teamMember"
                required
                value={state.teamMember}
                onChange={(e) => {
                  setState({ ...state, teamMember: e.target.value });
                }}
              >
                <option value hidden selected>
                  Select Job
                </option>
                <option>Sumit Saha</option>
                <option>Saad Hasan</option>
                <option>Akash Ahmed</option>
                <option>Md Salahuddin</option>
                <option>Riyadh Hassan</option>
                <option>Ferdous Hassan</option>
                <option>Arif Almas</option>
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              <select
                id="lws-projectName"
                name="projectName"
                required
                value={state.projectName}
                onChange={(e) => {
                  setState({ ...state, projectName: e.target.value });
                }}
              >
                <option value hidden selected>
                  Select Project
                </option>
                <option>Scoreboard</option>
                <option>Flight Booking</option>
                <option>Product Cart</option>
                <option>Book Store</option>
                <option>Blog Application</option>
                <option>Job Finder</option>
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                id="lws-deadline"
                required
                value={state.deadline}
                onChange={(e) => {
                  setState({ ...state, deadline: e.target.value });
                }}
              />
            </div>
            <div className="text-right">
              <button type="submit" className="lws-submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default EditTask;
